var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-radio-group',{model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},[_c('v-label',[_vm._v("Itens Excluídos")]),_vm._l((_vm.options),function(option){return _c('v-radio',{key:option,attrs:{"label":_vm.$t(`filters.labels.${option}`),"value":option}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }